import { render } from "./UniLink.vue?vue&type=template&id=626f91ec"
import script from "./UniLink.vue?vue&type=script&lang=js"
export * from "./UniLink.vue?vue&type=script&lang=js"

import exportComponent from "C:\\OpenServer\\domains\\front-studixy.dm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__